<script  setup>
import {reactive, ref, watch} from "vue";
import {ElButton, ElCol, ElDatePicker, ElLoading, ElMessage, ElRow, ElText} from "element-plus";
import axios from "axios";
import {CirclePlus, Delete, Edit} from "@element-plus/icons-vue";
import moment from 'moment';

const props = defineProps({
    enquiry:Object,
    qid:Number,
    bqid:Number
});

const enquiryid=props.enquiry.id;

const emit = defineEmits(['saved']);

const addmodel=ref(false);


const ruleFormRef = ref();

const rules = reactive({
    name: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    type: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    gender: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    dob: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
});

const addform=reactive(
    {
        "enquiry_id":enquiryid,
        "id":'',
        "name":'',
        "type":'',
        "gender":'',
        "dob":'',
        "passport_no":'',
        "passport_expiry":'',
        "panno":'',
        "aadhaarno":''
    }
)

const types=["Adult","Child","Infant"];
const genders=["Male","Female"];

const adding=ref(false);

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {

            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });

            axios.post('/enquiry/addpax', addform).then(function (response) {
                ElMessage({
                    message: 'Passanger Added Sucessfully.',
                    type: 'success',
                })

                loading.close();
                addform.id="";
                addform.dob="";
                addform.name="";
                addform.type="";
                addform.gender="";
                addform.aadhaarno="";
                addform.panno="";
                addform.passport_expiry="";
                addform.passport_no="";

                addmodel.value=false;
                emit('saved')

            })
                .catch(function (error) {

                    loading.close()
                });

        }
    })
}


const deletei = (item)=>{
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });

    axios.post('/enquiry/deletepax', {id:item.id}).then(function (response) {
        ElMessage({
            message: 'Passanger Deleted Sucessfully.',
            type: 'success',
        })

        loading.close();
        emit('saved')

    })
        .catch(function (error) {

            loading.close()
        });
}

const edit = (item)=>{
    addmodel.value=true;
    addform.id=item.id;
    addform.dob=moment(item.dob, 'DD-MM-YYYY').format('YYYY-MM-DD');
    addform.type=item.type;
    addform.name=item.name;
    addform.panno=item.panno;
    addform.passport_no=item.passport_no;
    if(item.passport_expiry){
        addform.passport_expiry=moment(item.passport_expiry, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    addform.aadhaarno=item.aadhaarno;
    addform.gender=item.gender;
}
const resetform = ()=>{
    addform.id="";
    addform.dob="";
    addform.name="";
    addform.type="";
    addform.gender="";
    addform.aadhaarno="";
    addform.panno="";
    addform.passport_expiry="";
    addform.passport_no="";
}

</script>

<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Passengers</span>
            <span>

                      <el-button class="white-btn ml-2" size="small" @click="addmodel=true;resetform();">Add</el-button>


            </span>
         </template>

        <el-row v-if="enquiry.passangers.length>0">
            <el-col >
                <el-table size="small" :data="enquiry.passangers" border style="width: 100%">
                    <el-table-column prop="department" label="#"  width="40" >
                        <template #default="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>

                    <el-table-column prop="type" label="Type"  />
                    <el-table-column prop="name" label="Name"  />
                    <el-table-column prop="gender" label="Gender"  />
                    <el-table-column prop="dob" label="DOB"  />
                    <el-table-column prop="passport_no" label="Passport Number"  />
                    <el-table-column prop="passport_expiry" label="Passport Expiry"  />
                    <el-table-column prop="panno" label="PAN"  />
                    <el-table-column prop="aadhaarno" label="Aadhaar No."  />

                    <el-table-column prop="department" label="Action"  fixed="right" width="100">
                        <template #default="scope">

                            <div >
                                <el-button  type="primary" size="small" @click="edit(scope.row)">
                                    <el-icon>
                                        <Edit />
                                    </el-icon>
                                </el-button>
                                <el-button   type="danger" size="small" @click="deletei(scope.row)">
                                    <el-icon>
                                        <Delete />
                                    </el-icon>
                                </el-button>
                            </div>



                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

    </el-card>

    <el-dialog
        v-model="addmodel"
        title="Add Passanger"
        width="50%"

    >

        <el-form
            ref="ruleFormRef"
            :model="addform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"
            :rules="rules"

        >

            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="Type"  prop="type"
                                  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-select
                            placeholder="Type"
                            style="width: 100%"
                            v-model="addform.type"
                        >
                            <el-option
                                v-for="item in types"
                                :key="item"
                                :label="item"
                                :value="item"
                            />

                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="Gender"  prop="gender"
                                  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-select
                            placeholder="Type"
                            style="width: 100%"
                            v-model="addform.gender"
                        >
                            <el-option
                                v-for="item in genders"
                                :key="item"
                                :label="item"
                                :value="item"
                            />

                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Name" prop="name">
                        <el-input v-model="addform.name"  placeholder="Name" />
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Date of Birth" prop="dob">
                        <el-date-picker type="date" v-model="addform.dob"  placeholder="Date of Birth"  format="DD/MM/YYYY"
                                        value-format="YYYY-MM-DD" />
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Passport Number" prop="passport_no">
                        <el-input v-model="addform.passport_no"  placeholder="Passport Number" />
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Passport Expiry" prop="passport_expiry">
                        <el-date-picker type="date" v-model="addform.passport_expiry"  placeholder="Passport Expiry"  format="DD/MM/YYYY"
                                        value-format="YYYY-MM-DD" />
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="PAN" prop="panno">
                        <el-input v-model="addform.panno"  placeholder="PAN" />
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Aadhaar No." prop="aadhaarno">
                        <el-input v-model="addform.aadhaarno"  placeholder="Aadhaar No." />
                    </el-form-item>

                </el-col>



            </el-row>

        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="addmodel=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)" :disabled="adding" :loading="adding">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>

</template>

